import PropTypes from "prop-types";
import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import { bindActionCreators } from "redux";
import momentPropTypes from "react-moment-proptypes";
import ReportDefinitions from "../../../common/config/ReportDefinitions";
import capeNotificationContainer from "../../../common/CapeNotificationContainer";
import { warningNotification } from "../../../common/redux/actions/CapeNotificationActions";
import {
  saveRecentUserReportRequestActionCreator,
  saveLastUserSelectionRequestActionCreator,
  saveLastUserCountryUnlocodeSelectionRequestActionCreator,
  saveLastUserOperatorEdiMailboxSelectionRequestActionCreator,
  saveLastUserOperatorImpcProductSelectionRequestActionCreator,
  saveLastUserOperatorProductSelectionRequestActionCreator,
  saveLastUserOperatorNaImpcSelectionRequestActionCreator,
  saveLastUserOperatorNaSelectionRequestActionCreator,
  saveLastUserOperatorImpcSelectionRequestActionCreator,
  saveLastUserOperatorSelectionRequestActionCreator,
  saveLastUserOperatorNaImpcProductSelectionRequestActionCreator,
  saveLastUserOperatorNaProductSelectionRequestActionCreator,
  saveLastUserMrdOperatorImpcSelectionRequestActionCreator,
  saveLastUserOperatorNaCarrierProductSelectionRequestActionCreator,
  saveLastUserCarrierSelectionRequestActionCreator,
  saveLastUserHandlerSelectionRequestActionCreator,
  currentUserReportActionCreator,
  fetchUserReportDefinitionsRequestActionCreator,
  sentLastSelections,
} from "../../../user/redux/actions/UserActions";
import SelectionCriteriaDto from "../models/SelectionCriteriaDto";
import {
  getCurrentReport,
  getLastSelections,
  getRecentSelections,
  getUserReports,
  getUserLoaded,
} from "../../../user/redux/selectors/UserReportSelectors";
import {
  getSelectionCriteria,
  getWizardValidationErrors,
} from "../../../wizard/common/redux/selectors/SelectionCriteriaWizardSelectors";
import {
  dayPeriodSelected,
  storeLastPeriodSelection,
} from "../../../wizard/period-selector/redux/actions/PeriodSelectionActions";
import DespatchMeasurementsDailyEvolutionContainer from "../../despatch/measurements/daily/evolution/containers/DespatchMeasurementsDailyEvolutionContainer";
import DespatchMeasurementsHourlyEvolutionContainer from "../../despatch/measurements/hourly/evolution/containers/DespatchMeasurementsHourlyEvolutionContainer";
import DespatchMonitoringOverviewContainer from "../../despatch/monitoring/overview/containers/DespatchMonitoringOverviewContainer";
import DespatchMonitoringReceptacleDetailsContainer from "../../despatch/monitoring/receptacle-details/containers/DespatchMonitoringReceptacleDetailsContainer";
import DespatchMonitoringResponseAnalysisContainer from "../../despatch/monitoring/response-analysis/containers/DespatchMonitoringResponseAnalysisContainer";
import DespatchMonitoringResponsePerformanceContainer from "../../despatch/monitoring/response-performance/containers/DespatchMonitoringResponsePerformanceContainer";
import DespatchMonitoringEventTargetsContainer from "../../despatch/monitoring/event-targets/containers/DespatchMonitoringEventTargetsContainer";
import DespatchParticularsContentContainer from "../../despatch/particulars/content/containers/DespatchParticularsContentContainer";
import DespatchParticularsFormatOfContentsContainer from "../../despatch/particulars/format-of-contents/containers/DespatchParticularsFormatOfContentsContainer";
import DespatchParticularsOverviewContainer from "../../despatch/particulars/overview/containers/DespatchParticularsOverviewContainer";
import DespatchParticularsReceptacleDetailsContainer from "../../despatch/particulars/receptacle-details/containers/DespatchParticularsReceptacleDetailsContainer";
import DespatchParticularsReceptacleTypeContainer from "../../despatch/particulars/receptacle-type/containers/DespatchParticularsReceptacleTypeContainer";
import DespatchImpcToImpcPerformanceContainer from "../../despatch/performance/impc-to-impc/containers/DespatchImpcToImpcPerformanceContainer";
import DespatchPostToPostPerformanceContainer from "../../despatch/performance/post-to-post/containers/DespatchPostToPostPerformanceContainer";
import CompliancePredesResdesOperatorMismatchContainer from "../../compliance/mismatch/predes-resdes-operator/containers/CompliancePredesResdesOperatorMismatchContainer";
import ComplianceReceptacleIdVsDespatchIdSubclassMismatchContainer from "../../compliance/mismatch/receptacle-id-vs-despatch-id/containers/ComplianceReceptacleIdVsDespatchIdSubclassMismatchContainer";
import CompliancePredesResdesMailboxMismatchContainer from "../../compliance/mismatch/predes-resdes-mailbox/containers/CompliancePredesResdesMailboxMismatchContainer";
import CompliancePredesResdesInterchangeEdiMessageContainer from "../../compliance/edi-message/predes-resdes-interchange/containers/CompliancePredesResdesInterchangeEdiMessageContainer";
import CompliancePredesResdesDespatchesSummaryContainer from "../../compliance/despatch/predes-resdes-despatches/containers/CompliancePredesResdesDespatchesSummaryContainer";
import CompliancePredesResdesDespatchesDetailsContainer from "../../compliance/despatch/predes-resdes-despatches/containers/CompliancePredesResdesDespatchesDetailsContainer";
import CompliancePredesDestinationImpcCodeNotRegisteredSummaryContainer from "../../compliance/predes/destination-impc-code-not-registered/containers/CompliancePredesDestinationImpcCodeNotRegisteredSummaryContainer";
import CompliancePredesDestinationImpcCodeNotRegisteredDetailsContainer from "../../compliance/predes/destination-impc-code-not-registered/containers/CompliancePredesDestinationImpcCodeNotRegisteredDetailsContainer";
import ReceptacleMonitoringResponsePerformanceContainer from "../../compliance/receptacle/monitoring/response-performance/containers/ReceptacleMonitoringResponsePerformanceContainer";
import ReceptacleEventIrregularitiesContainer from "../../compliance/event-irregularities/receptacle-event-irregularities/containers/ReceptacleEventIrregularitiesContainer";
import IpcEquipmentPoolsPredesResdesAnalysisIpcBagIsContainer from "../../compliance/ipc-equipment-pools/predes-resdes-analysis/ipc-bag-is/containers/IpcEquipmentPoolsPredesResdesAnalysisIpcBagIsContainer";
import IpcEquipmentPoolsPredesResdesAnalysisIpcTrayIlContainer from "../../compliance/ipc-equipment-pools/predes-resdes-analysis/ipc-tray-il/containers/IpcEquipmentPoolsPredesResdesAnalysisIpcTrayIlContainer";
import IpcEquipmentPoolsPredesResdesAnalysisIpcPalletBoxIbContainer from "../../compliance/ipc-equipment-pools/predes-resdes-analysis/ipc-pallet-box-ib/containers/IpcEquipmentPoolsPredesResdesAnalysisIpcPalletBoxIbContainer";
import IpcEquipmentPoolsPredesResdesAnalysisReceptaclesContainer from "../../compliance/ipc-equipment-pools/predes-resdes-analysis/receptacles/containers/IpcEquipmentPoolsPredesResdesAnalysisReceptaclesContainer";
import PredesOriginImpcCodeNotRegisteredSummaryContainer from "../../compliance/predes/origin-impc-code-not-registered/summary/containers/PredesOriginImpcCodeNotRegisteredSummaryContainer";
import PredesOriginImpcCodeNotRegisteredDetailsContainer from "../../compliance/predes/origin-impc-code-not-registered/details/containers/PredesOriginImpcCodeNotRegisteredDetailsContainer";
import OriginImpcOperatorPredesSenderMismatchSummaryContainer from "../../compliance/mismatch/predes-sender/summary/containers/OriginImpcOperatorPredesSenderMismatchSummaryContainer";
import OriginImpcOperatorPredesSenderMismatchDetailsContainer from "../../compliance/mismatch/predes-sender/details/containers/OriginImpcOperatorPredesSenderMismatchDetailsContainer";
import MultiplePredesSummaryContainer from "../../compliance/predes/multiple/summary/containers/MultiplePredesSummaryContainer";
import MultiplePredesDetailsContainer from "../../compliance/predes/multiple/details/containers/MultiplePredesDetailsContainer";
import ComplianceResconConsignmentIdNotInPreconSummaryContainer from "../../compliance/rescon/consignment-id-not-in-precon/containers/ComplianceResconConsignmentIdNotInPreconSummaryContainer";
import ComplianceResconConsignmentIdNotInPreconDetailsContainer from "../../compliance/rescon/consignment-id-not-in-precon/containers/ComplianceResconConsignmentIdNotInPreconDetailsContainer";
import ItemsHandoverDataAirSummaryContainer from "../../kpi/item-handover-data-air/summary/containers/ItemsHandoverDataAirSummaryContainer";
import ItemsHandoverDataAirDetailsContainer from "../../kpi/item-handover-data-air/details/containers/ItemsHandoverDataAirDetailsContainer";
import PredesComplianceIncorrectLocationCodeUsageSummaryContainer from "../../compliance/predes/incorrect-location-code-usage/containers/PredesComplianceIncorrectLocationCodeUsageSummaryContainer";
import PredesComplianceIncorrectLocationCodeUsageDetailsContainer from "../../compliance/predes/incorrect-location-code-usage/containers/PredesComplianceIncorrectLocationCodeUsageDetailsContainer";
import PredesComplianceGapsInDespatchNumbersContainer from "../../compliance/predes/gaps-in-despatch-numbers/containers/PredesComplianceGapsInDespatchNumbersContainer";
import ItemsHandoverDataRoadSummaryContainer from "../../kpi/item-handover-data-road/summary/containers/ItemsWithHandoverDataRoadSummaryContainer";
import ItemsHandoverDataRoadDetailsContainer from "../../kpi/item-handover-data-road/details/containers/ItemsWithHandoverDataRoadDetailsContainer";
import PredesImpcCodeUsageNonComplianceSummaryContainer from "../../edi-compliance/predes/impc-code-usage-non-compliance/summary/containers/PredesImpcCodeUsageNonComplianceSummaryContainer";
import PredesImpcCodeUsageNonComplianceDetailsContainer from "../../edi-compliance/predes/impc-code-usage-non-compliance/details/containers/PredesImpcCodeUsageNonComplianceDetailsContainer";
import PredesPlannedTransportAnomaliesOriginSummaryContainer from "../../irregularities/predes/planned-transport-anomalies-origin/summary/containers/PredesPlannedTransportAnomaliesOriginSummaryContainer";
import PredesPlannedTransportAnomaliesOriginDetailsContainer from "../../irregularities/predes/planned-transport-anomalies-origin/details/containers/PredesPlannedTransportAnomaliesOriginDetailsContainer";
import PredesPlannedTransportAnomaliesDestinationSummaryContainer from "../../irregularities/predes/planned-transport-anomalies-destination/summary/containers/PredesPlannedTransportAnomaliesDestinationSummaryContainer";
import PredesPlannedTransportAnomaliesDestinationDetailsContainer from "../../irregularities/predes/planned-transport-anomalies-destination/details/containers/PredesPlannedTransportAnomaliesDestinationDetailsContainer";
import TrackedItemsInPredesSummaryContainer from "../../kpi/tracked-items-in-predes/containers/TrackedItemsInPredesSummaryContainer";
import TrackedItemsInPredesDetailsContainer from "../../kpi/tracked-items-in-predes/containers/TrackedItemsInPredesDetailsContainer";
import PredesTimelinessSummaryContainer from "../../edi-messages/predes/timeliness/summary/containers/PredesTimelinessSummaryContainer";
import PredesTimelinessDetailsContainer from "../../edi-messages/predes/timeliness/details/containers/PredesTimelinessDetailsContainer";
import PredesComplianceMissingRequiredElementsSummaryContainer from "../../edi-messages/predes/compliance/missing-required-elements/summary/containers/PredesComplianceMissingRequiredElementsSummaryContainer";
import PredesComplianceMissingRequiredElementsDetailsContainer from "../../edi-messages/predes/compliance/missing-required-elements/details/containers/PredesComplianceMissingRequiredElementsDetailsContainer";
import PredesComplianceContainer from "../../edi-compliance/predes/compliance/containers/PredesComplianceContainer";
import ReceptaclesInPreconNotInPredesSummaryContainer from "../../kpi/receptacles-in-precon-not-in-predes/summary/containers/ReceptaclesInPreconNotInPredesSummaryContainer";
import ReceptaclesInPreconNotInPredesDetailsContainer from "../../kpi/receptacles-in-precon-not-in-predes/details/containers/ReceptaclesInPreconNotInPredesDetailsContainer";
import ReceptaclesInPredesNotInPreconSummaryContainer from "../../kpi/receptacles-in-predes-not-in-precon/summary/containers/ReceptaclesInPredesNotInPreconSummaryContainer";
import ReceptaclesInPredesNotInPreconDetailsContainer from "../../kpi/receptacles-in-predes-not-in-precon/details/containers/ReceptaclesInPredesNotInPreconDetailsContainer";
import PredesComplianceMissingMandatoryElementsErrorMessagesContainer from "../../edi-compliance/predes/missing-mandatory-elements/error-messages/containers/PredesComplianceMissingMandatoryElementsErrorMessagesContainer";
import PredesComplianceMissingMandatoryElementsKeyDetailsContainer from "../../edi-compliance/predes/missing-mandatory-elements/key-details/containers/PredesComplianceMissingMandatoryElementsKeyDetailsContainer";
import PredesComplianceMissingMandatoryElementsSummaryContainer from "../../edi-compliance/predes/missing-mandatory-elements/summary/containers/PredesComplianceMissingMandatoryElementsSummaryContainer";
import PredesComplianceMessageMappingErrorsSummaryContainer from "../../edi-compliance/predes/message-mapping-errors/summary/containers/PredesComplianceMessageMappingErrorsSummaryContainer";
import PredesComplianceMessageMappingErrorsErrorMessagesContainer from "../../edi-compliance/predes/message-mapping-errors/error-messages/containers/PredesComplianceMessageMappingErrorsErrorMessagesContainer";
import PredesComplianceMessageMappingErrorsKeyDetailsContainer from "../../edi-compliance/predes/message-mapping-errors/key-details/containers/PredesComplianceMessageMappingErrorsKeyDetailsContainer";
import ReceptaclesInPredesNotInCarditSummaryContainer from "../../kpi/receptacles-in-predes-not-in-cardit/summary/containers/ReceptaclesInPredesNotInCarditSummaryContainer";
import ReceptaclesInPredesNotInCarditDetailsContainer from "../../kpi/receptacles-in-predes-not-in-cardit/details/containers/ReceptaclesInPredesNotInCarditDetailsContainer";
import InterchangeDetailsContainer from "../../edi-messages/interchange-details/containers/InterchangeDetailsContainer";
import PreconResconConsignmentsSummaryContainer from "../../irregularities/precon-rescon-consignments/containers/PreconResconConsignmentsSummaryContainer";
import PreconResconConsignmentsDetailsContainer from "../../irregularities/precon-rescon-consignments/containers/PreconResconConsignmentsDetailsContainer";
import InterchangeProcessingSummaryContainer from "../../edi-messages/interchange-processing/summary/containers/InterchangeProcessingSummaryContainer";
import InterchangeProcessingDetailsContainer from "../../edi-messages/interchange-processing/details/containers/InterchangeProcessingDetailsContainer";
import IntrefSequenceVerificationContainer from "../../edi-compliance/intref/intref-sequence-verification/containers/IntrefSequenceVerificationContainer";
import CarditResditInterchangesContainer from "../../edi-messages/cardit-resdit-interchanges/containers/CarditResditInterchangesContainer";
import ConsignmentResponseAnalysisContainer from "../../consignment/response-analysis/containers/ConsignmentResponseAnalysisContainer";
import ConsignmentParticularsContainer from "../../consignment/particulars/containers/ConsignmentParticularsContainer";
import ConsignmentReceptacleDetailsContainer from "../../consignment/receptacle-details/containers/ConsignmentReceptacleDetailsContainer";
import MrdXmlAnalysisContainer from "../../mrd/xml-analysis/containers/MrdXmlAnalysisContainer";
import HandoverRegistrationAtOriginContainer from "../../mrd/handover-registration-at-origin/containers/HandoverRegistrationAtOriginContainer";
import OperationalAnalysisContainer from "../../mrd/operational-analysis/containers/OperationalAnalysisContainer";
import OperationalAnalysisDailyContainer from "../../mrd/operational-analysis/daily/containers/OperationalAnalysisDailyContainer";
import MrdPodOverviewContainer from "../../mrd/pod-overview/containers/MrdPodOverviewContainer";
import CarditNestingCarrierContainer from "../../consignment/cardit-nesting/carrier/containers/CarditNestingCarrierContainer";
import CarditNestingLocationContainer from "../../consignment/cardit-nesting/location/containers/CarditNestingLocationContainer";
import CarditNestingDetailsContainer from "../../consignment/cardit-nesting/details/containers/CarditNestingDetailsContainer";
import SaintPierreEtMiquelonSummaryContainer from "../../consignment/saint-pierre-et-miquelon/summary/containers/SaintPierreEtMiquelonSummaryContainer";
import SaintPierreEtMiquelonDetailsContainer from "../../consignment/saint-pierre-et-miquelon/details/containers/SaintPierreEtMiquelonDetailsContainer";
import CarditResditBestPracticeElementsContainer from "../../consignment/cardit-resdit-best-practice-elements/containers/CarditResditBestPracticeElementsContainer";
import Resdit7421PerformanceCarrierContainer from "../../consignment/resdit-74-21-performance/carrier/containers/Resdit7421PerformanceCarrierContainer";
import Resdit7421PerformanceLocationContainer from "../../consignment/resdit-74-21-performance/location/containers/Resdit7421PerformanceLocationContainer";
import Resdit7421PerformanceDetailsContainer from "../../consignment/resdit-74-21-performance/details/containers/Resdit7421PerformanceDetailsContainer";
import CarditCriticalElementsCarrierContainer from "../../consignment/cardit-critical-elements/carrier/containers/CarditCriticalElementsCarrierContainer";
import CarditCriticalElementsLocationContainer from "../../consignment/cardit-critical-elements/location/containers/CarditCriticalElementsLocationContainer";
import CarditCriticalElementsDetailsContainer from "../../consignment/cardit-critical-elements/details/containers/CarditCriticalElementsDetailsContainer";
import CarrierResdit7421PerformanceOperatorContainer from "../../carrier/resdit-74-21-performance/operator/containers/CarrierResdit7421PerformanceOperatorContainer";
import CarrierResdit7421PerformanceLocationContainer from "../../carrier/resdit-74-21-performance/location/containers/CarrierResdit7421PerformanceLocationContainer";
import CarrierResdit7421PerformanceDetailsContainer from "../../carrier/resdit-74-21-performance/details/containers/CarrierResdit7421PerformanceDetailsContainer";
import CarrierNestingOperatorContainer from "../../carrier/nesting/operator/containers/CarrierNestingOperatorContainer";
import CarrierNestingLocationContainer from "../../carrier/nesting/location/containers/CarrierNestingLocationContainer";
import CarrierNestingDetailsContainer from "../../carrier/nesting/details/containers/CarrierNestingDetailsContainer";
import MrdXmlDailyAnalysisContainer from "../../mrd/xml-daily-analysis/containers/MrdXmlDailyAnalysisContainer";
import CarditTimelinessAnalysisContainer from "../../consignment/cardit-timeliness-analysis/containers/CarditTimelinessAnalysisContainer";
import CarrierM39ComplianceOperatorContainer from "../../carrier/m39-compliance/operator/containers/CarrierM39ComplianceOperatorContainer";
import CarrierM39ComplianceLocationContainer from "../../carrier/m39-compliance/location/containers/CarrierM39ComplianceLocationContainer";
import CarrierM39ComplianceDetailsContainer from "../../carrier/m39-compliance/details/containers/CarrierM39ComplianceDetailsContainer";
import CarrierMailRegistrationDeviceDeliverySummaryContainer from "../../handler/carrier-mail-registration-device-delivery/summary/containers/CarrierMailRegistrationDeviceDeliverySummaryContainer";
import CarrierMailRegistrationDeviceDeliveryCarrierPerformanceContainer from "../../handler/carrier-mail-registration-device-delivery/carrier-performance/containers/CarrierMailRegistrationDeviceDeliveryCarrierPerformanceContainer";
import CarrierMailRegistrationDeviceDeliveryDetailsContainer from "../../handler/carrier-mail-registration-device-delivery/details/containers/CarrierMailRegistrationDeviceDeliveryDetailsContainer";
import CarrierCarditResditBestPracticeElementsContainer from "../../carrier/cardit-resdit-best-practice-elements/containers/CarrierCarditResditBestPracticeElementsContainer";
import HandlerMailRegistrationDeviceDeliverySummaryContainer from "../../carrier/handler-registration-device-delivery/summary/containers/HandlerMailRegistrationDeviceDeliverySummaryContainer";
import HandlerMailRegistrationDeviceDeliveryCarrierPerformanceContainer from "../../carrier/handler-registration-device-delivery/carrier-performance/containers/HandlerMailRegistrationDeviceDeliveryCarrierPerformanceContainer";
import HandlerMailRegistrationDeviceDeliveryDetailsContainer from "../../carrier/handler-registration-device-delivery/details/containers/HandlerMailRegistrationDeviceDeliveryDetailsContainer";
import CarditByReceivingAirlineContainer from "../../edi-exchange-overview/cardit-by-receiving-airline/container/CarditByReceivingAirlineContainer";
import CarditByReceivingAirlineNumberedContainer from "../../edi-exchange-overview/cardit-by-receiving-airline/container/CarditByReceivingAirlineNumberedContainer";
import CarditBySendingPostSignedContainer from "../../edi-exchange-overview/cardit-by-sending-post/containers/CarditBySendingPostSignedContainer";
import CarditBySendingPostNumberedContainer from "../../edi-exchange-overview/cardit-by-sending-post/containers/CarditBySendingPostNumberedContainer";
import ResditByReceivingPostSignedContainer from "../../edi-exchange-overview/resdit-by-receiving-post/containers/ResditByReceivingPostSignedContainer";
import ResditByReceivingPostNumberedContainer from "../../edi-exchange-overview/resdit-by-receiving-post/containers/ResditByReceivingPostNumberedContainer";
import ResditBySendingAirlineContainer from "../../edi-exchange-overview/resdit-by-sending-airline/container/ResditBySendingAirlineContainer";
import ResditBySendingAirlineNumberedContainer from "../../edi-exchange-overview/resdit-by-sending-airline/container/ResditBySendingAirlineNumberedContainer";
import TransportExceptionsContainer from "../../despatch/transport-exceptions/containers/TransportExceptionsContainer";
import ReceptacleTransportOverviewContainer from "../../monitoring/receptacle/transport-overview/containers/ReceptacleTransportOverviewContainer";
import ReceptacleOverviewContainer from "../../monitoring/receptacle/overview/containers/ReceptacleOverviewContainer";
import CarditLinkTraceContainer from "../../cardit/cardit-link-trace/containers/CarditLinkTraceContainer";
import HandlerMonitoringContainer from "../../mrd/handler-monitoring/containers/HandlerMonitoringContainer";
import PaperFreeMonitoringPostSummaryContainer from "../../paper-free/monitoring-post/containers/PaperFreeMonitoringPostSummaryContainer";
import PaperFreeMonitoringPostDetailsContainer from "../../paper-free/monitoring-post/containers/PaperFreeMonitoringPostDetailsContainer";
import CarrierPaperFreeMonitoringPostSummaryContainer from "../../carrier/paper-free-monitoring-post/summary/containers/PaperFreeMonitoringPostSummaryContainer";
import CarrierPaperFreeMonitoringPostDetailsContainer from "../../carrier/paper-free-monitoring-post/details/containers/PaperFreeMonitoringPostDetailsContainer";
import CarrierAnalysisContainer from "../../mrd/carrier-analysis/containers/CarrierAnalysisContainer";
import CarditResditEventOverviewContainer from "../../consignment/cardit-resdit-event-overview/containers/CarditResditEventOverviewContainer";
import ResdesManagementSummaryEpgContainer from "../../epg/resdes-management-summary/containers/ResdesManagementSummaryEpgContainer";
import PaperFreeMonitoringCarrierSummaryContainer from "../../paper-free/monitoring-carrier/summary/containers/PaperFreeMonitoringCarrierSummaryContainer";
import PaperFreeMonitoringCarrierDetailsContainer from "../../paper-free/monitoring-carrier/details/containers/PaperFreeMonitoringCarrierDetailsContainer";
import CarrierPaperFreeMonitoringSummaryContainer from "../../carrier/paper-free-monitoring-carrier/summary/containers/CarrierPaperFreeMonitoringSummaryContainer";
import CarrierPaperFreeMonitoringDetailsContainer from "../../carrier/paper-free-monitoring-carrier/details/containers/CarrierPaperFreeMonitoringDetailsContainer";
import EpgLinkByLinkContainer from "../../epg/link-by-link-report/containers/EpgLinkByLinkContainer";
import HandoverAnalysisAtDestinationContainer from "../../consignment/handover-analysis-destination/containers/HandoverAnalysisAtDestinationContainer";
import MessageCapabilityOverviewContainer from "../../edi-exchange/message-capability-overview/containers/MessageCapabilityOverviewContainer";
import MessageProfileContainer from "../../edi-exchange/message-profile/containers/MessageProfileContainer";
import EdiExchangeLetterContainer from "../../edi-exchange/predes-v21-overview/letter/containers/EdiExchangeLetterContainer";
import EdiExchangeParcelContainer from "../../edi-exchange/predes-v21-overview/parcel/containers/EdiExchangeParcelContainer";
import EdiExchangeEmsContainer from "../../edi-exchange/predes-v21-overview/ems/containers/EdiExchangeEmsContainer";
import IpcTrayUsageContainer from "../../amt-reports/tray-usage-report/containers/IpcTrayUsageContainer";
import MixedTrayUsageContainer from "../../amt-reports/mixed-tray-usage-report/containers/MixedTrayUsageContainer";
import BagUsageContainer from "../../amt-reports/bag-usage-report/containers/BagUsageContainer";
import PalletBoxUsageContainer from "../../amt-reports/pallet-box-usage-report/containers/PalletBoxUsageContainer";
import ComparativeTrayUsageContainer from "../../amt-reports/comparative-tray-usage-report/containers/ComparativeTrayUsageContainer";
import ComparativeBagUsageContainer from "../../amt-reports/comparative-bag-usage-report/containers/ComparativeBagUsageContainer";
import ComparativePalletBoxUsageContainer from "../../amt-reports/comparative-pallet-box-usage-report/containers/ComparativePalletBoxUsageContainer";
import ReceptaclePodPerformanceSummaryContainer from "../../mrd/receptacle-pod-performance/summary/containers/ReceptaclePodPerformanceSummaryContainer";
import ReceptaclePodPerformanceDetailsContainer from "../../mrd/receptacle-pod-performance/details/containers/ReceptaclePodPerformanceDetailsContainer";
import CapeUsageMonitoringContainer from "../../user-monitoring/cape-usage-monitoring/monitoring/containers/CapeUsageMonitoringContainer";
import CapeUsageMonitoringByOperatorContainer from "../../user-monitoring/cape-usage-monitoring/monitoring-by-operator/containers/CapeUsageMonitoringByOperatorContainer";
import CapeUsageMonitoringByUserContainer from "../../user-monitoring/cape-usage-monitoring/monitoring-by-user/containers/CapeUsageMonitoringByUserContainer";
import ItemOverviewV1Container from "../../item/item-overview/v1/containers/ItemOverviewV1Container";
import ItemOverviewV2Container from "../../item/item-overview/v2/containers/ItemOverviewV2Container";
import ItemOverviewDetails200Container from "../../item/item-overview/details/containers/ItemOverviewDetails200Container";
import {
  getDayPickerDates,
  getMonthPickerDates,
  getPeriodSelectorEndDate,
  getPeriodSelectorStartDate,
  getWeekPickerDates,
  getSelectedDatePicker,
} from "../../../wizard/period-selector/redux/selectors/PeriodSelectionSelectors";
import ThresholdsForCertificationSummaryContainer from "../../certification/thresholds-for-certification/summary/containers/ThresholdsForCertificationSummaryContainer";
import ThresholdsForCertificationDetailsContainer from "../../certification/thresholds-for-certification/details/containers/ThresholdsForCertificationDetailsContainer";

export class ReportContainer extends Component {
  constructor(props) {
    super(props);
    /* this.state = {
      display: false,
    }; */

    this.timer = null;
  }

  UNSAFE_componentWillMount() {
    const { validationErrors } = this.props;
    console.log(validationErrors, "valerror");
    if (validationErrors.length) {
      this.props.warningNotification(
        validationErrors.reduce(
          (message, error) => `${message + error.message}\n`,
          ""
        )
      );
      // this.props.history.goBack();
    }
  }

  componentDidMount() {
    const { currentReport } = this.props;
    // Only fetch user data if not already loaded
    if (this.props.userReports.length === 0 && !this.props.userLoaded) {
      this.props.fetchUserReportDefinitionsRequestActionCreator();
    }
    if (currentReport?.reportCode === this.props.match.params.reportName) {
      this.props.currentUserReportActionCreator(
        this.props.match.params.reportName
      );
    }
    const reportCode = currentReport?.reportCode;
    const { reportName } = this.props.match.params;
    const { selectionCriteria } =
      ReportDefinitions[this.props.match.params.reportName];
    const params =
      selectionCriteria.getSaveLastUserSelectionRequestActionCreatorParams(
        this.props.selectionCriteria
      );
    // console.log(selectionCriteria, this.props.selectionCriteria, ReportDefinitions[this.props.match.params.reportName]);
    // console.log(this.props.currentReport, this.props.match.params.reportName, params, this.props.recentSelections);
    const currentRecentObj = {
      reportCode: this.props.match.params.reportName,
      requestBody: JSON.stringify({
        createTime: Date.now(),
        ...new SelectionCriteriaDto(
          this.props.selectionCriteria,
          ReportDefinitions[
            this.props.match.params.reportName
          ].selectionCriteria.items
        ),
      }),
    };

    if (this.props.recentSelections.requestBody) {
      const currentRequestBody = JSON.parse(currentRecentObj.requestBody);
      const deletedCurrentReqBody = _.omit(currentRequestBody, "createTime");
      const recentSelectionReqBody = JSON.parse(
        this.props.recentSelections.requestBody
      );
      const removedCreateTimeAbc = _.omit(recentSelectionReqBody, "createTime");
      if (
        !_.isEqual(deletedCurrentReqBody, removedCreateTimeAbc) &&
        reportCode === reportName
      ) {
        this.props.saveRecentUserReportRequestActionCreator({
          reportCode: this.props.match.params.reportName,
          requestBody: JSON.stringify({
            createTime: Date.now(),
            ...new SelectionCriteriaDto(
              this.props.selectionCriteria,
              ReportDefinitions[
                this.props.match.params.reportName
              ].selectionCriteria.items
            ),
          }),
        });
      }
    } else {
      this.props.saveRecentUserReportRequestActionCreator({
        reportCode: this.props.match.params.reportName,
        requestBody: JSON.stringify({
          createTime: Date.now(),
          ...new SelectionCriteriaDto(
            this.props.selectionCriteria,
            ReportDefinitions[
              this.props.match.params.reportName
            ].selectionCriteria.items
          ),
        }),
      });
    }

    if (
      Object.keys(params).length !== 0 &&
      !_.isEqual(params, this.props.lastSelections) &&
      reportCode === reportName
    ) {
      switch (selectionCriteria.saveLastUserSelectionRequestActionCreatorKey) {
        case "saveLastUserOperatorImpcProductSelectionRequestActionCreator":
          this.props.saveLastUserOperatorImpcProductSelectionRequestActionCreator(
            params
          );
          break;
        case "saveLastUserOperatorNaImpcSelectionRequestActionCreator":
          this.props.saveLastUserOperatorNaImpcSelectionRequestActionCreator(
            params
          );
          break;
        case "saveLastUserOperatorImpcSelectionRequestActionCreator":
          this.props.saveLastUserOperatorImpcSelectionRequestActionCreator(
            params
          );
          break;
        case "saveLastUserOperatorNaImpcProductSelectionRequestActionCreator":
          this.props.saveLastUserOperatorNaImpcProductSelectionRequestActionCreator(
            params
          );
          break;
        case "saveLastUserOperatorEdiMailboxSelectionRequestActionCreator":
          this.props.saveLastUserOperatorEdiMailboxSelectionRequestActionCreator(
            params
          );
          break;
        case "saveLastUserCountryUnlocodeSelectionRequestActionCreator":
          this.props.saveLastUserCountryUnlocodeSelectionRequestActionCreator(
            params
          );
          break;
        case "saveLastUserMrdOperatorImpcSelectionRequestActionCreator":
          this.props.saveLastUserMrdOperatorImpcSelectionRequestActionCreator(
            params
          );
          break;
        case "saveLastUserOperatorNaCarrierProductSelectionRequestActionCreator":
          this.props.saveLastUserOperatorNaCarrierProductSelectionRequestActionCreator(
            params
          );
          break;
        case "saveLastUserCarrierSelectionRequestActionCreator":
          this.props.saveLastUserCarrierSelectionRequestActionCreator(params);
          break;
        case "saveLastUserHandlerSelectionRequestActionCreator":
          this.props.saveLastUserHandlerSelectionRequestActionCreator(params);
          break;
        case "saveLastUserOperatorProductSelectionRequestActionCreator":
          this.props.saveLastUserOperatorProductSelectionRequestActionCreator(
            params
          );
          break;
        case "saveLastUserOperatorNaSelectionRequestActionCreator":
          this.props.saveLastUserOperatorNaSelectionRequestActionCreator(
            params
          );
          break;
        case "saveLastUserOperatorNaProductSelectionRequestActionCreator":
          this.props.saveLastUserOperatorNaProductSelectionRequestActionCreator(
            params
          );
          break;
        case "saveLastUserOperatorSelectionRequestActionCreator":
          this.props.saveLastUserOperatorSelectionRequestActionCreator(params);
          break;
        default:
          break;
      }
    }
    this.props.sentLastSelections(params);
    this.props.storeLastPeriodSelection(this.props.selectionCriteria.period);
    const data = {
      startDate: this.props.startDate,
      endDate: this.props.endDate,
      dayPicker: this.props.dayPicker,
    };
    if (this.props.datePicker === "DAY") {
      localStorage.setItem("dayPeriod", JSON.stringify(data));
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const queryDate = undefined;
    if (!queryDate) {
      return;
    }
    const datesAreDifferent = !(
      nextProps.selectionCriteria.period.startDate.isSame(queryDate, "day") &&
      nextProps.selectionCriteria.period.endDate.isSame(queryDate, "day")
    );
    if (datesAreDifferent) {
      const date = new Date(queryDate);
      this.props.dayPeriodSelected({
        startDate: date,
        endDate: date,
      });
    }
  }

  componentDidUpdate() {
    /* const { validationErrors } = this.props;
    if (!this.state.display) {
      setTimeout(() => {
        this.setState({
          display: true,
        });
      }, 1000);
    } else {
      clearTimeout(this.timer);
    }
    if (validationErrors.length && this.state.display) {
      console.log('@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@');
      this.props.warningNotification(validationErrors
        .reduce((message, error) => `${message + error.message}\n`, ''));
      this.props.history.goBack();
    } */
    if (
      this.props.currentReport &&
      this.props.currentReport.reportCode !== this.props.match.params.reportName
    ) {
      this.props.currentUserReportActionCreator(
        this.props.match.params.reportName
      );
    }
  }

  render() {
    const {
      currentReport,
      match: {
        params: { reportName },
      },
    } = this.props;

    if (!currentReport) {
      return <div />;
    }
    switch (reportName) {
      case ReportDefinitions.DESPATCH_PARTICULARS_OVERVIEW.id:
        return <DespatchParticularsOverviewContainer {...this.props} />;
      case ReportDefinitions.DESPATCH_PARTICULARS_RECEPTACLE_TYPE.id:
        return <DespatchParticularsReceptacleTypeContainer {...this.props} />;
      case ReportDefinitions.DESPATCH_PARTICULARS_RECEPTACLE_DETAILS.id:
        return (
          <DespatchParticularsReceptacleDetailsContainer {...this.props} />
        );
      case ReportDefinitions.DESPATCH_PARTICULARS_CONTENT.id:
        return <DespatchParticularsContentContainer {...this.props} />;
      case ReportDefinitions.POST_TO_POST_DESPATCH_PERFORMANCE.id:
        return <DespatchPostToPostPerformanceContainer {...this.props} />;
      case ReportDefinitions.IMPC_TO_IMPC_DESPATCH_PERFORMANCE.id:
        return <DespatchImpcToImpcPerformanceContainer {...this.props} />;
      case ReportDefinitions.DESPATCH_MONITORING_RESPONSE_PERFORMANCE.id:
        return (
          <DespatchMonitoringResponsePerformanceContainer {...this.props} />
        );
      case ReportDefinitions.DESPATCH_PARTICULARS_FORMAT_OF_CONTENTS.id:
        return <DespatchParticularsFormatOfContentsContainer {...this.props} />;
      case ReportDefinitions.DESPATCH_MONITORING_RECEPTACLE_DETAILS.id:
        return <DespatchMonitoringReceptacleDetailsContainer {...this.props} />;
      case ReportDefinitions.DESPATCH_MONITORING_OVERVIEW.id:
        return <DespatchMonitoringOverviewContainer {...this.props} />;
      case ReportDefinitions.DESPATCH_MONITORING_RESPONSE_ANALYSIS.id:
        return <DespatchMonitoringResponseAnalysisContainer {...this.props} />;
      case ReportDefinitions.DESPATCH_MONITORING_EVENT_TARGETS.id:
        return <DespatchMonitoringEventTargetsContainer {...this.props} />;
      case ReportDefinitions.DESPATCH_MEASUREMENTS_DAILY_EVOLUTION.id:
        return <DespatchMeasurementsDailyEvolutionContainer {...this.props} />;
      case ReportDefinitions.DESPATCH_MEASUREMENTS_HOURLY_EVOLUTION.id:
        return <DespatchMeasurementsHourlyEvolutionContainer {...this.props} />;
      case ReportDefinitions.PREDES_RESDES_OPERATOR_MISMATCH.id:
        return (
          <CompliancePredesResdesOperatorMismatchContainer {...this.props} />
        );
      case ReportDefinitions.MISMATCHED_SUBCLASS_RECEPTACLE_ID_VS_DESPATCH_ID
        .id:
        return (
          <ComplianceReceptacleIdVsDespatchIdSubclassMismatchContainer
            {...this.props}
          />
        );
      case ReportDefinitions.PREDES_RESDES_MAILBOX_MISMATCH.id:
        return (
          <CompliancePredesResdesMailboxMismatchContainer {...this.props} />
        );
      case ReportDefinitions.PREDES_AND_RESDES_INTERCHANGES.id:
        return (
          <CompliancePredesResdesInterchangeEdiMessageContainer
            {...this.props}
          />
        );
      case ReportDefinitions.PREDES_RESDES_DESPATCHES_SUMMARY.id:
        return (
          <CompliancePredesResdesDespatchesSummaryContainer {...this.props} />
        );
      case ReportDefinitions.PREDES_RESDES_DESPATCHES_DETAILS.id:
        return (
          <CompliancePredesResdesDespatchesDetailsContainer {...this.props} />
        );
      case ReportDefinitions.PREDES_DESTINATION_IMPC_CODE_NOT_REGISTERED_SUMMARY
        .id:
        return (
          <CompliancePredesDestinationImpcCodeNotRegisteredSummaryContainer
            {...this.props}
          />
        );
      case ReportDefinitions.PREDES_DESTINATION_IMPC_CODE_NOT_REGISTERED_DETAILS
        .id:
        return (
          <CompliancePredesDestinationImpcCodeNotRegisteredDetailsContainer
            {...this.props}
          />
        );
      case ReportDefinitions.RECEPTACLE_MONITORING_RESPONSE_PERFORMANCE.id:
        return (
          <ReceptacleMonitoringResponsePerformanceContainer {...this.props} />
        );
      case ReportDefinitions.RECEPTACLE_EVENT_IRREGULARITIES.id:
        return <ReceptacleEventIrregularitiesContainer {...this.props} />;
      case ReportDefinitions.IPC_BAG_IS_PREDES_RESDES_ANALYSIS.id:
        return (
          <IpcEquipmentPoolsPredesResdesAnalysisIpcBagIsContainer
            {...this.props}
          />
        );
      case ReportDefinitions.IPC_TRAY_IL_PREDES_RESDES_ANALYSIS.id:
        return (
          <IpcEquipmentPoolsPredesResdesAnalysisIpcTrayIlContainer
            {...this.props}
          />
        );
      case ReportDefinitions.IPC_PALLET_BOX_IB_PREDES_RESDES_ANALYSIS.id:
        return (
          <IpcEquipmentPoolsPredesResdesAnalysisIpcPalletBoxIbContainer
            {...this.props}
          />
        );
      case ReportDefinitions.PREDES_ORIGIN_IMPC_CODE_NOT_REGISTERED_SUMMARY.id:
        return (
          <PredesOriginImpcCodeNotRegisteredSummaryContainer {...this.props} />
        );
      case ReportDefinitions.PREDES_ORIGIN_IMPC_CODE_NOT_REGISTERED_DETAILS.id:
        return (
          <PredesOriginImpcCodeNotRegisteredDetailsContainer {...this.props} />
        );
      case ReportDefinitions.ORIGIN_IMPC_OPERATOR_PREDES_SENDER_MISMATCH_SUMMARY
        .id:
        return (
          <OriginImpcOperatorPredesSenderMismatchSummaryContainer
            {...this.props}
          />
        );
      case ReportDefinitions.ORIGIN_IMPC_OPERATOR_PREDES_SENDER_MISMATCH_DETAILS
        .id:
        return (
          <OriginImpcOperatorPredesSenderMismatchDetailsContainer
            {...this.props}
          />
        );
      case ReportDefinitions.RECEPTACLES_PREDES_RESDES_ANALYSIS.id:
        return (
          <IpcEquipmentPoolsPredesResdesAnalysisReceptaclesContainer
            {...this.props}
          />
        );
      case ReportDefinitions.MULTIPLE_PREDES_SUMMARY.id:
        return <MultiplePredesSummaryContainer {...this.props} />;
      case ReportDefinitions.MULTIPLE_PREDES_DETAILS.id:
        return <MultiplePredesDetailsContainer {...this.props} />;
      case ReportDefinitions.RESCON_CONSIGNMENT_ID_NOT_IN_PRECON_SUMMARY.id:
        return (
          <ComplianceResconConsignmentIdNotInPreconSummaryContainer
            {...this.props}
          />
        );
      case ReportDefinitions.RESCON_CONSIGNMENT_ID_NOT_IN_PRECON_DETAILS.id:
        return (
          <ComplianceResconConsignmentIdNotInPreconDetailsContainer
            {...this.props}
          />
        );
      case ReportDefinitions.ITEMS_WITH_HANDOVER_DATA_AIR_SUMMARY.id:
        return <ItemsHandoverDataAirSummaryContainer {...this.props} />;
      case ReportDefinitions.ITEMS_WITH_HANDOVER_DATA_AIR_DETAILS.id:
        return <ItemsHandoverDataAirDetailsContainer {...this.props} />;
      case ReportDefinitions
        .PREDES_COMPLIANCE_INCORRECT_LOCATION_CODE_USAGE_SUMMARY.id:
        return (
          <PredesComplianceIncorrectLocationCodeUsageSummaryContainer
            {...this.props}
          />
        );
      case ReportDefinitions
        .PREDES_COMPLIANCE_INCORRECT_LOCATION_CODE_USAGE_DETAILS.id:
        return (
          <PredesComplianceIncorrectLocationCodeUsageDetailsContainer
            {...this.props}
          />
        );
      case ReportDefinitions.PREDES_COMPLIANCE_GAPS_IN_DESPATCH_NUMBERS.id:
        return (
          <PredesComplianceGapsInDespatchNumbersContainer {...this.props} />
        );
      case ReportDefinitions.ITEMS_WITH_HANDOVER_DATA_ROAD_SUMMARY.id:
        return <ItemsHandoverDataRoadSummaryContainer {...this.props} />;
      case ReportDefinitions.ITEMS_WITH_HANDOVER_DATA_ROAD_DETAILS.id:
        return <ItemsHandoverDataRoadDetailsContainer {...this.props} />;
      case ReportDefinitions.PREDES_IMPC_CODE_USAGE_NON_COMPLIANCE_SUMMARY.id:
        return (
          <PredesImpcCodeUsageNonComplianceSummaryContainer {...this.props} />
        );
      case ReportDefinitions.PREDES_IMPC_CODE_USAGE_NON_COMPLIANCE_DETAILS.id:
        return (
          <PredesImpcCodeUsageNonComplianceDetailsContainer {...this.props} />
        );
      case ReportDefinitions.PREDES_PLANNED_TRANSPORT_ANOMALIES_ORIGIN_SUMMARY
        .id:
        return (
          <PredesPlannedTransportAnomaliesOriginSummaryContainer
            {...this.props}
          />
        );
      case ReportDefinitions.PREDES_PLANNED_TRANSPORT_ANOMALIES_ORIGIN_DETAILS
        .id:
        return (
          <PredesPlannedTransportAnomaliesOriginDetailsContainer
            {...this.props}
          />
        );
      case ReportDefinitions
        .PREDES_PLANNED_TRANSPORT_ANOMALIES_DESTINATION_SUMMARY.id:
        return (
          <PredesPlannedTransportAnomaliesDestinationSummaryContainer
            {...this.props}
          />
        );
      case ReportDefinitions
        .PREDES_PLANNED_TRANSPORT_ANOMALIES_DESTINATION_DETAILS.id:
        return (
          <PredesPlannedTransportAnomaliesDestinationDetailsContainer
            {...this.props}
          />
        );
      case ReportDefinitions.TRACKED_ITEMS_IN_PREDES_SUMMARY.id:
        return <TrackedItemsInPredesSummaryContainer {...this.props} />;
      case ReportDefinitions.TRACKED_ITEMS_IN_PREDES_DETAILS.id:
        return <TrackedItemsInPredesDetailsContainer {...this.props} />;
      case ReportDefinitions.PREDES_TIMELINESS_SUMMARY.id:
        return <PredesTimelinessSummaryContainer {...this.props} />;
      case ReportDefinitions.PREDES_TIMELINESS_DETAILS.id:
        return <PredesTimelinessDetailsContainer {...this.props} />;
      case ReportDefinitions.PREDES_COMPLIANCE_MISSING_REQUIRED_ELEMENTS_SUMMARY
        .id:
        return (
          <PredesComplianceMissingRequiredElementsSummaryContainer
            {...this.props}
          />
        );
      case ReportDefinitions.PREDES_COMPLIANCE_MISSING_REQUIRED_ELEMENTS_DETAILS
        .id:
        return (
          <PredesComplianceMissingRequiredElementsDetailsContainer
            {...this.props}
          />
        );
      case ReportDefinitions.PREDES_COMPLIANCE.id:
        return <PredesComplianceContainer {...this.props} />;
      case ReportDefinitions.RECEPTACLES_IN_PRECON_NOT_IN_PREDES_SUMMARY.id:
        return (
          <ReceptaclesInPreconNotInPredesSummaryContainer {...this.props} />
        );
      case ReportDefinitions.RECEPTACLES_IN_PRECON_NOT_IN_PREDES_DETAILS.id:
        return (
          <ReceptaclesInPreconNotInPredesDetailsContainer {...this.props} />
        );
      case ReportDefinitions.RECEPTACLES_IN_PREDES_NOT_IN_PRECON_SUMMARY.id:
        return (
          <ReceptaclesInPredesNotInPreconSummaryContainer {...this.props} />
        );
      case ReportDefinitions.RECEPTACLES_IN_PREDES_NOT_IN_PRECON_DETAILS.id:
        return (
          <ReceptaclesInPredesNotInPreconDetailsContainer {...this.props} />
        );
      case ReportDefinitions
        .PREDES_COMPLIANCE_MISSING_MANDATORY_ELEMENTS_ERROR_MESSAGES.id:
        return (
          <PredesComplianceMissingMandatoryElementsErrorMessagesContainer
            {...this.props}
          />
        );
      case ReportDefinitions
        .PREDES_COMPLIANCE_MISSING_MANDATORY_ELEMENTS_KEY_DETAILS.id:
        return (
          <PredesComplianceMissingMandatoryElementsKeyDetailsContainer
            {...this.props}
          />
        );
      case ReportDefinitions
        .PREDES_COMPLIANCE_MISSING_MANDATORY_ELEMENTS_SUMMARY.id:
        return (
          <PredesComplianceMissingMandatoryElementsSummaryContainer
            {...this.props}
          />
        );
      case ReportDefinitions.PREDES_COMPLIANCE_MESSAGE_MAPPING_ERRORS_SUMMARY
        .id:
        return (
          <PredesComplianceMessageMappingErrorsSummaryContainer
            {...this.props}
          />
        );
      case ReportDefinitions.PREDES_COMPLIANCE_MESSAGE_MAPPING_ERRORS_MESSAGES
        .id:
        return (
          <PredesComplianceMessageMappingErrorsErrorMessagesContainer
            {...this.props}
          />
        );
      case ReportDefinitions
        .PREDES_COMPLIANCE_MESSAGE_MAPPING_ERRORS_KEY_DETAILS.id:
        return (
          <PredesComplianceMessageMappingErrorsKeyDetailsContainer
            {...this.props}
          />
        );
      case ReportDefinitions.RECEPTACLES_IN_PREDES_NOT_IN_CARDIT_SUMMARY.id:
        return (
          <ReceptaclesInPredesNotInCarditSummaryContainer {...this.props} />
        );
      case ReportDefinitions.RECEPTACLES_IN_PREDES_NOT_IN_CARDIT_DETAILS.id:
        return (
          <ReceptaclesInPredesNotInCarditDetailsContainer {...this.props} />
        );
      case ReportDefinitions.INTERCHANGE_DETAILS.id:
        return <InterchangeDetailsContainer {...this.props} />;
      case ReportDefinitions.PRECON_RESCON_CONSIGNMENTS_SUMMARY.id:
        return <PreconResconConsignmentsSummaryContainer {...this.props} />;
      case ReportDefinitions.PRECON_RESCON_CONSIGNMENTS_DETAILS.id:
        return <PreconResconConsignmentsDetailsContainer {...this.props} />;
      case ReportDefinitions.INTERCHANGE_PROCESSING_SUMMARY.id:
        return <InterchangeProcessingSummaryContainer {...this.props} />;
      case ReportDefinitions.INTERCHANGE_PROCESSING_DETAILS.id:
        return <InterchangeProcessingDetailsContainer {...this.props} />;
      case ReportDefinitions.INTREF_SEQUENCE_VERIFICATION.id:
        return <IntrefSequenceVerificationContainer {...this.props} />;
      case ReportDefinitions.CARDIT_RESDIT_INTERCHANGES.id:
        return <CarditResditInterchangesContainer {...this.props} />;
      case ReportDefinitions.CONSIGNMENT_RESPONSE_ANALYSIS.id:
        return <ConsignmentResponseAnalysisContainer {...this.props} />;
      case ReportDefinitions.CONSIGNMENT_PARTICULARS.id:
        return <ConsignmentParticularsContainer {...this.props} />;
      case ReportDefinitions.CONSIGNMENT_RECEPTACLE_DETAILS.id:
        return <ConsignmentReceptacleDetailsContainer {...this.props} />;
      case ReportDefinitions.MRD_XML_ANALYSIS.id:
        return <MrdXmlAnalysisContainer {...this.props} />;
      case ReportDefinitions.HANDOVER_REGISTRATION_AT_ORIGIN.id:
        return <HandoverRegistrationAtOriginContainer {...this.props} />;
      case ReportDefinitions.OPERATIONAL_ANALYSIS.id:
        return <OperationalAnalysisContainer {...this.props} />;
      case ReportDefinitions.OPERATIONAL_ANALYSIS_DAILY.id:
        return <OperationalAnalysisDailyContainer {...this.props} />;
      case ReportDefinitions.MRD_POD_OVERVIEW.id:
        return <MrdPodOverviewContainer {...this.props} />;
      case ReportDefinitions.MRD_XML_DAILY_ANALYSIS.id:
        return <MrdXmlDailyAnalysisContainer {...this.props} />;
      case ReportDefinitions.CARDIT_NESTING_CARRIER.id:
        return <CarditNestingCarrierContainer {...this.props} />;
      case ReportDefinitions.CARDIT_NESTING_LOCATION.id:
        return <CarditNestingLocationContainer {...this.props} />;
      case ReportDefinitions.CARDIT_NESTING_DETAILS.id:
        return <CarditNestingDetailsContainer {...this.props} />;
      case ReportDefinitions.SAINT_PIERRE_ET_MIQUELON_SUMMARY.id:
        return <SaintPierreEtMiquelonSummaryContainer {...this.props} />;
      case ReportDefinitions.SAINT_PIERRE_ET_MIQUELON_DETAILS.id:
        return <SaintPierreEtMiquelonDetailsContainer {...this.props} />;
      case ReportDefinitions.CARDIT_RESDIT_BEST_PRACTICE_ELEMENTS_106.id:
        return <CarditResditBestPracticeElementsContainer {...this.props} />;
      case ReportDefinitions.RESDIT_74_21_PERFORMANCE_CARRIER_107B.id:
        return <Resdit7421PerformanceCarrierContainer {...this.props} />;
      case ReportDefinitions.RESDIT_74_21_PERFORMANCE_LOCATION_107B.id:
        return <Resdit7421PerformanceLocationContainer {...this.props} />;
      case ReportDefinitions.RESDIT_74_21_PERFORMANCE_DETAILS_107B.id:
        return <Resdit7421PerformanceDetailsContainer {...this.props} />;
      case ReportDefinitions.CARDIT_CRITICAL_ELEMENTS_CARRIER.id:
        return <CarditCriticalElementsCarrierContainer {...this.props} />;
      case ReportDefinitions.CARDIT_CRITICAL_ELEMENTS_LOCATION.id:
        return <CarditCriticalElementsLocationContainer {...this.props} />;
      case ReportDefinitions.CARDIT_CRITICAL_ELEMENTS_DETAILS.id:
        return <CarditCriticalElementsDetailsContainer {...this.props} />;
      case ReportDefinitions.RESDIT_74_21_PERFORMANCE_OPERATOR_802.id:
        return (
          <CarrierResdit7421PerformanceOperatorContainer {...this.props} />
        );
      case ReportDefinitions.RESDIT_74_21_PERFORMANCE_LOCATION_802.id:
        return (
          <CarrierResdit7421PerformanceLocationContainer {...this.props} />
        );
      case ReportDefinitions.RESDIT_74_21_PERFORMANCE_DETAILS_802.id:
        return <CarrierResdit7421PerformanceDetailsContainer {...this.props} />;
      case ReportDefinitions.CARDIT_NESTING_OPERATOR_801.id:
        return <CarrierNestingOperatorContainer {...this.props} />;
      case ReportDefinitions.CARDIT_NESTING_LOCATION_801.id:
        return <CarrierNestingLocationContainer {...this.props} />;
      case ReportDefinitions.CARDIT_NESTING_DETAILS_801.id:
        return <CarrierNestingDetailsContainer {...this.props} />;
      case ReportDefinitions.CARDIT_TIMELINESS_ANALYSIS.id:
        return <CarditTimelinessAnalysisContainer {...this.props} />;
      case ReportDefinitions.CARDIT_CRITICAL_ELEMENTS_800_OPERATOR.id:
        return <CarrierM39ComplianceOperatorContainer {...this.props} />;
      case ReportDefinitions.CARDIT_CRITICAL_ELEMENTS_800_LOCATION.id:
        return <CarrierM39ComplianceLocationContainer {...this.props} />;
      case ReportDefinitions.CARDIT_CRITICAL_ELEMENTS_800_DETAILS.id:
        return <CarrierM39ComplianceDetailsContainer {...this.props} />;
      case ReportDefinitions.CARRIER_MAIL_REGISTRATION_DEVICE_DELIVERY_SUMMARY
        .id:
        return (
          <CarrierMailRegistrationDeviceDeliverySummaryContainer
            {...this.props}
          />
        );
      case ReportDefinitions
        .CARRIER_MAIL_REGISTRATION_DEVICE_DELIVERY_CARRIER_PERFORMANCE.id:
        return (
          <CarrierMailRegistrationDeviceDeliveryCarrierPerformanceContainer
            {...this.props}
          />
        );
      case ReportDefinitions.CARRIER_MAIL_REGISTRATION_DEVICE_DELIVERY_DETAILS
        .id:
        return (
          <CarrierMailRegistrationDeviceDeliveryDetailsContainer
            {...this.props}
          />
        );
      case ReportDefinitions.CARDIT_RESDIT_BEST_PRACTICE_ELEMENTS_804.id:
        return (
          <CarrierCarditResditBestPracticeElementsContainer {...this.props} />
        );
      case ReportDefinitions.HANDLER_MAIL_REGISTRATION_DEVICE_DELIVERY_SUMMARY
        .id:
        return (
          <HandlerMailRegistrationDeviceDeliverySummaryContainer
            {...this.props}
          />
        );
      case ReportDefinitions
        .HANDLER_MAIL_REGISTRATION_DEVICE_DELIVERY_CARRIER_PERFORMANCE.id:
        return (
          <HandlerMailRegistrationDeviceDeliveryCarrierPerformanceContainer
            {...this.props}
          />
        );
      case ReportDefinitions.HANDLER_MAIL_REGISTRATION_DEVICE_DELIVERY_DETAILS
        .id:
        return (
          <HandlerMailRegistrationDeviceDeliveryDetailsContainer
            {...this.props}
          />
        );
      case ReportDefinitions.CARDIT_BY_RECEIVING_AIRLINE.id:
        return <CarditByReceivingAirlineContainer {...this.props} />;
      case ReportDefinitions.CARDIT_BY_RECEIVING_AIRLINE_NUMBERED.id:
        return <CarditByReceivingAirlineNumberedContainer {...this.props} />;
      case ReportDefinitions.CARDIT_BY_SENDING_POST.id:
        return <CarditBySendingPostSignedContainer {...this.props} />;
      case ReportDefinitions.CARDIT_BY_SENDING_POST_NUMBERED.id:
        return <CarditBySendingPostNumberedContainer {...this.props} />;
      case ReportDefinitions.RESDIT_BY_RECEIVING_POST.id:
        return <ResditByReceivingPostSignedContainer {...this.props} />;
      case ReportDefinitions.RESDIT_BY_RECEIVING_POST_NUMBERED.id:
        return <ResditByReceivingPostNumberedContainer {...this.props} />;
      case ReportDefinitions.RESDIT_BY_SENDING_AIRLINE.id:
        return <ResditBySendingAirlineContainer {...this.props} />;
      case ReportDefinitions.RESDIT_BY_SENDING_AIRLINE_NUMBERED.id:
        return <ResditBySendingAirlineNumberedContainer {...this.props} />;
      case ReportDefinitions.TRANSPORT_EXCEPTIONS.id:
        return <TransportExceptionsContainer {...this.props} />;
      case ReportDefinitions.RECEPTACLE_TRANSPORT_OVERVIEW.id:
        return <ReceptacleTransportOverviewContainer {...this.props} />;
      case ReportDefinitions.RECEPTACLE_OVERVIEW.id:
        return <ReceptacleOverviewContainer {...this.props} />;
      case ReportDefinitions.CARDIT_LINK_TRACE.id:
        return <CarditLinkTraceContainer {...this.props} />;
      case ReportDefinitions.HANDLER_MONITORING.id:
        return <HandlerMonitoringContainer {...this.props} />;
      case ReportDefinitions.CARRIER_ANALYSIS_411.id:
        return <CarrierAnalysisContainer {...this.props} />;
      case ReportDefinitions.CARDIT_RESDIT_EVENT_OVERVIEW_105.id:
        return <CarditResditEventOverviewContainer {...this.props} />;
      case ReportDefinitions.PAPER_FREE_MONITORING_POST_900_SUMMARY.id:
        return <PaperFreeMonitoringPostSummaryContainer {...this.props} />;
      case ReportDefinitions.PAPER_FREE_MONITORING_POST_900_DETAILS.id:
        return <PaperFreeMonitoringPostDetailsContainer {...this.props} />;
      case ReportDefinitions.RESDES_MANAGEMENT_SUMMARY_EPG.id:
        return <ResdesManagementSummaryEpgContainer {...this.props} />;
      case ReportDefinitions.PAPER_FREE_MONITORING_CARRIER_901_SUMMARY.id:
        return <PaperFreeMonitoringCarrierSummaryContainer {...this.props} />;
      case ReportDefinitions.PAPER_FREE_MONITORING_CARRIER_901_DETAILS.id:
        return <PaperFreeMonitoringCarrierDetailsContainer {...this.props} />;
      case ReportDefinitions.PAPER_FREE_MONITORING_CARRIER_903_SUMMARY.id:
        return <CarrierPaperFreeMonitoringSummaryContainer {...this.props} />;
      case ReportDefinitions.PAPER_FREE_MONITORING_CARRIER_903_DETAILS.id:
        return <CarrierPaperFreeMonitoringDetailsContainer {...this.props} />;
      case ReportDefinitions.PAPER_FREE_MONITORING_POST_902_SUMMARY.id:
        return (
          <CarrierPaperFreeMonitoringPostSummaryContainer {...this.props} />
        );
      case ReportDefinitions.PAPER_FREE_MONITORING_POST_902_DETAILS.id:
        return (
          <CarrierPaperFreeMonitoringPostDetailsContainer {...this.props} />
        );
      case ReportDefinitions.EPG_LINK_BY_LINK_REPORT_013.id:
        return <EpgLinkByLinkContainer {...this.props} />;
      case ReportDefinitions.HANDOVER_ANALYSIS_AT_DESTINATION.id:
        return <HandoverAnalysisAtDestinationContainer {...this.props} />;
      case ReportDefinitions.MESSAGE_CAPABILITY_OVERVIEW.id:
        return <MessageCapabilityOverviewContainer {...this.props} />;
      case ReportDefinitions.MESSAGE_PROFILE.id:
        return <MessageProfileContainer {...this.props} />;
      case ReportDefinitions.EDI_EXCHANGE_LETTER_706.id:
        return <EdiExchangeLetterContainer {...this.props} />;
      case ReportDefinitions.EDI_EXCHANGE_PARCEL_706.id:
        return <EdiExchangeParcelContainer {...this.props} />;
      case ReportDefinitions.EDI_EXCHANGE_EMS_706.id:
        return <EdiExchangeEmsContainer {...this.props} />;
      case ReportDefinitions.TRAY_USAGE_940.id:
        return <IpcTrayUsageContainer {...this.props} />;
      case ReportDefinitions.MIXED_TRAY_USAGE_942.id:
        return <MixedTrayUsageContainer {...this.props} />;
      case ReportDefinitions.BAG_USAGE_950.id:
        return <BagUsageContainer {...this.props} />;
      case ReportDefinitions.PALLET_BOX_USAGE_960.id:
        return <PalletBoxUsageContainer {...this.props} />;
      case ReportDefinitions.COMPARATIVE_TRAY_USAGE_941.id:
        return <ComparativeTrayUsageContainer {...this.props} />;
      case ReportDefinitions.COMPARATIVE_BAG_USAGE_951.id:
        return <ComparativeBagUsageContainer {...this.props} />;
      case ReportDefinitions.COMPARATIVE_PALLET_BOX_USAGE_961.id:
        return <ComparativePalletBoxUsageContainer {...this.props} />;
      case ReportDefinitions.RECEPTACLE_POD_PERFORMANCE_404_SUMMARY.id:
        return <ReceptaclePodPerformanceSummaryContainer {...this.props} />;
      case ReportDefinitions.RECEPTACLE_POD_PERFORMANCE_404_DETAILS.id:
        return <ReceptaclePodPerformanceDetailsContainer {...this.props} />;
      case ReportDefinitions.CAPE_USAGE_MONITORING_1000.id:
        return <CapeUsageMonitoringContainer {...this.props} />;
      case ReportDefinitions.CAPE_USAGE_MONITORING_BY_OPERATOR_1000.id:
        return <CapeUsageMonitoringByOperatorContainer {...this.props} />;
      case ReportDefinitions.CAPE_USAGE_MONITORING_BY_OPERATOR_USER_1000.id:
        return <CapeUsageMonitoringByUserContainer {...this.props} />;
      case ReportDefinitions.ITEM_OVERVIEW_V1_200.id:
        return <ItemOverviewV1Container {...this.props} />;
      case ReportDefinitions.ITEM_OVERVIEW_V2_201.id:
        return <ItemOverviewV2Container {...this.props} />;
      case ReportDefinitions.ITEM_OVERVIEW_DETAILS_200.id:
        return <ItemOverviewDetails200Container {...this.props} />;
      case ReportDefinitions.THRESHOLDS_FOR_CERTIFICATION_545_SUMMARY.id:
        return <ThresholdsForCertificationSummaryContainer {...this.props} />;
      case ReportDefinitions.THRESHOLDS_FOR_CERTIFICATION_545_DETAILS.id:
        return <ThresholdsForCertificationDetailsContainer {...this.props} />;
      default:
        return <div>Report not found</div>;
    }
  }
}

function mapStateToProps(state) {
  return {
    validationErrors: getWizardValidationErrors(state),
    selectionCriteria: getSelectionCriteria(state),
    currentReport: getCurrentReport(state),
    userReports: getUserReports(state),
    userLoaded: getUserLoaded(state),
    startDate: getPeriodSelectorStartDate(state),
    endDate: getPeriodSelectorEndDate(state),
    weekPicker: getWeekPickerDates(state),
    monthPicker: getMonthPickerDates(state),
    dayPicker: getDayPickerDates(state),
    datePicker: getSelectedDatePicker(state),
    recentSelections: getRecentSelections(state),
    lastSelections: getLastSelections(state),
  };
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      saveRecentUserReportRequestActionCreator,
      saveLastUserSelectionRequestActionCreator,
      saveLastUserCountryUnlocodeSelectionRequestActionCreator,
      saveLastUserOperatorEdiMailboxSelectionRequestActionCreator,
      saveLastUserOperatorImpcProductSelectionRequestActionCreator,
      saveLastUserOperatorProductSelectionRequestActionCreator,
      saveLastUserOperatorNaImpcSelectionRequestActionCreator,
      saveLastUserOperatorNaSelectionRequestActionCreator,
      saveLastUserOperatorImpcSelectionRequestActionCreator,
      saveLastUserOperatorSelectionRequestActionCreator,
      saveLastUserOperatorNaImpcProductSelectionRequestActionCreator,
      saveLastUserOperatorNaProductSelectionRequestActionCreator,
      saveLastUserMrdOperatorImpcSelectionRequestActionCreator,
      saveLastUserOperatorNaCarrierProductSelectionRequestActionCreator,
      saveLastUserCarrierSelectionRequestActionCreator,
      saveLastUserHandlerSelectionRequestActionCreator,
      storeLastPeriodSelection,
      currentUserReportActionCreator,
      fetchUserReportDefinitionsRequestActionCreator,
      dayPeriodSelected,
      warningNotification,
      sentLastSelections,
    },
    dispatch
  );

ReportContainer.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      reportName: PropTypes.string.isRequired,
    }),
  }),
  routes: PropTypes.shape({
    mailProcessingCenterSelection: PropTypes.string,
  }),
  warningNotification: PropTypes.func,
  validationErrors: PropTypes.arrayOf(PropTypes.object),
  saveRecentUserReportRequestActionCreator: PropTypes.func,
  saveLastUserSelectionRequestActionCreator: PropTypes.func,
  saveLastUserCountryUnlocodeSelectionRequestActionCreator: PropTypes.func,
  saveLastUserOperatorEdiMailboxSelectionRequestActionCreator: PropTypes.func,
  saveLastUserOperatorImpcProductSelectionRequestActionCreator: PropTypes.func,
  saveLastUserOperatorProductSelectionRequestActionCreator: PropTypes.func,
  saveLastUserOperatorNaImpcSelectionRequestActionCreator: PropTypes.func,
  saveLastUserOperatorNaSelectionRequestActionCreator: PropTypes.func,
  saveLastUserOperatorImpcSelectionRequestActionCreator: PropTypes.func,
  saveLastUserOperatorSelectionRequestActionCreator: PropTypes.func,
  saveLastUserOperatorNaImpcProductSelectionRequestActionCreator:
    PropTypes.func,
  saveLastUserOperatorNaProductSelectionRequestActionCreator: PropTypes.func,
  saveLastUserMrdOperatorImpcSelectionRequestActionCreator: PropTypes.func,
  saveLastUserOperatorNaCarrierProductSelectionRequestActionCreator:
    PropTypes.func,
  saveLastUserCarrierSelectionRequestActionCreator: PropTypes.func,
  saveLastUserHandlerSelectionRequestActionCreator: PropTypes.func,
  storeLastPeriodSelection: PropTypes.func,
  currentUserReportActionCreator: PropTypes.func,
  fetchUserReportDefinitionsRequestActionCreator: PropTypes.func,
  dayPeriodSelected: PropTypes.func,
  selectionCriteria: PropTypes.objectOf(PropTypes.shape),
  userReports: PropTypes.arrayOf(PropTypes.object),
  userLoaded: PropTypes.bool,
  currentReport: PropTypes.objectOf(PropTypes.shape),
  router: PropTypes.shape({
    goBack: PropTypes.func,
    location: PropTypes.shape({
      query: PropTypes.shape({
        date: PropTypes.string,
      }),
    }),
  }),
  // eslint-disable-next-line react/no-typos
  startDate: momentPropTypes.momentObj,
  // eslint-disable-next-line react/no-typos
  endDate: momentPropTypes.momentObj,
  dayPicker: PropTypes.shape({
    startDate: PropTypes.instanceOf(Date),
    endDate: PropTypes.instanceOf(Date),
  }),
  weekPicker: PropTypes.shape({
    startDate: PropTypes.instanceOf(Date),
    endDate: PropTypes.instanceOf(Date),
  }),
  monthPicker: PropTypes.shape({
    startDate: PropTypes.instanceOf(Date),
    endDate: PropTypes.instanceOf(Date),
  }),
  datePicker: PropTypes.string,
  recentSelections: PropTypes.arrayOf(PropTypes.object),
  lastSelections: PropTypes.arrayOf(PropTypes.object),
  sentLastSelections: PropTypes.func,
};

export const ConnectedReportContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(ReportContainer);
export default capeNotificationContainer(ConnectedReportContainer);
